import ready from 'document-ready-promise';
import TaskPane from './TaskPane';

checkOfficeAppSupported().then(async (supported) => {
    await ready();

    if (supported) {
        let taskPane = new TaskPane();
        await taskPane.Initialize();
    } else {
        showUnsupportedMessage();
    }
}).catch(e => {
    console.error(e && (e.message || e));
});

async function checkOfficeAppSupported() {
    if (isOfficeUsingTrident()) {
        return false;
    }

    if (typeof Office === 'undefined' || typeof Office.onReady !== 'function') {
        return false;
    }

    await Office.onReady();
    return isOfficeRequirementSetSupported();
}
function isOfficeUsingTrident(): boolean {
    return navigator.userAgent.indexOf("Trident") !== -1;
}

function isOfficeRequirementSetSupported(): boolean {
    // Before using Word-specific APIs
    if (Office.context?.host === Office.HostType.Word &&
        Office.context?.requirements.isSetSupported('WordApi', '1.3')) {
        return true;
    }
    
    // Before using Excel-specific APIs
    if (Office.context?.host === Office.HostType.Excel &&
        Office.context?.requirements.isSetSupported('ExcelApi', '1.3')) {
        return true;
    }

    if (Office.context?.host === Office.HostType.PowerPoint &&
        Office.context?.requirements.isSetSupported('PowerPointApi', '1.10')) {
        return true;
    }

    return false;
}

function showUnsupportedMessage() {
    let iframe = document.getElementById('mainIFrame') as HTMLIFrameElement;
    iframe.onload = () => document.getElementById("loading-panel")!.style.display = "none";

     const host =
        (typeof Office !== 'undefined' && Office.context?.host === Office.HostType.Excel) ? 'Excel' :
        (typeof Office !== 'undefined' && Office.context?.host === Office.HostType.Word) ? 'Word' :
		(typeof Office !== 'undefined' && Office.context?.host === Office.HostType.PowerPoint) ? 'PowerPoint' :
        'Office';

    iframe.src = 'markunsupported.html?host=' + encodeURIComponent(host);
}
